import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage } from '@/features/notification/list-page';

export const Route = createFileRoute('/_authenticated/inbox')({
  component: InboxPage,
});

function InboxPage() {
  const { session } = Route.useRouteContext();
  return <NotificationsPage userId={session.user.id} />;
}
